<template lang="pug">
    div(v-if="reports.length > 0")
        div(style="max-width:890px; height:140px;")
            CalendarScroll
                ChartCalendarAnalysis(@clickPDF="clickPDF" :pdf_array="reports")

        div(style="max-width:890px;")
            template
                //- object(data="https://tv.streamfabriken.com/eg7-q3-2021" width="100%" style="height: calc( 100vh - 16rem );")
                object(:data="`${active_pdf_link}#view=FitH`" width="100%" style="height: calc( 100vh - 29rem );")
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import ChartCalendarAnalysis from "../../components/ChartCalendarAnalysis.vue";
import CalendarScroll from "../../components/CalendarScroll.vue";

export default {
    components: {
        ChartCalendarAnalysis,
        CalendarScroll
    },
    props: {
        stock_id: Number,
        company_id: Number
    },
    data() {
        return {
            checkReloadPDF: true,
            reports: [],
            years: ["2018", "2019", "2020", "2021"],  //TODO: change this to be year dynamic... before december
            quarters: ["Q1", "Q2" ,"Q3" ,"Q4", "FY"],
            activePeriod: null,
            activeGroupOnYear: null,
            active_pdf_link: null
        }
    },
    watch: {
        company_id() {
            this.init();
        },
        pdf() {
            this.init();
        }
    },
    methods: {
        clickPDF(pdf) {
            this.active_pdf_link = `/companyanalysis/${pdf}`;
        },
        init() {
            let analysis_array = this.getCompanyAnalysts;

            let analysis_init = analysis_array.filter(item => item.company_id == this.company_id);

            if (analysis_init.length > 0) {
                let analysis_order = _.orderBy(analysis_init, ['publish_date'],['asc']);

                analysis_order[analysis_order.length-1].active = true;

                this.reports = analysis_order;

                let active_pdf_link_init = analysis_order[analysis_order.length-1].pdf_link;

                this.active_pdf_link = '/companyanalysis/' + active_pdf_link_init;
            } else {
                this.reports = [];
            }
        }
    },
    computed: {
        ...mapGetters(['getCompanyAnalysts'])
    },
    mounted() {
        this.init();
    }
}
</script>

<style scoped>
table>tr>td{
    padding:6px 4px;
    border-spacing: 3px;
}

table.quater-table thead th {
    font-weight: unset;
}

>>> .set-pdf-file-container {
    width: 24px;
    height: 32px;
}

>>> .set-pdf-file-color {
    fill: #E72929;
}

>>> .set-pdf-file-active-container {
    width: 24px;
    height: 32px;
}

>>> .set-pdf-file-active-color {
    fill: #E72929;
}
</style>
